export default {
  key: 'system--canvas',
  routes: [/^\/dashboard$/, /^\/profile$/, /^\/studio$/, /^\/[^/]+\/[^/]+/],
  i18nNamespaces: ['canvas'],
  app: () => import('./app.js').then((m) => m.default),
  context: () => import('./context.js').then((m) => m.default),
  // NOTE: these lifecycle hooks are currently NOT invoked by bootShell or
  // wireGlobalListeners (no fetchOnMount caller exists — verified 2026-07-28);
  // the editor page's own ensureProjectLoaded does the real fetch. Kept for the
  // Phase-8 dispatcher, but corrected: the SDK facade is FLAT
  // (sdk.getProjectByKey — SERVICE_METHODS maps it to the project service);
  // `sdk.project.getProjectByKey` was a dead namespace that would have thrown,
  // the same class of bug bootShell's own comment calls out for
  // `sdk.organization?.get?.()`.
  fetchOnMount: ({ state, sdk, params }) => {
    if (params?.owner && params?.project) {
      return sdk.getProjectByKey({ owner: params.owner, key: params.project }).then((p) => {
        state.project = p
      })
    }
  },
  onParamsChange: ({ newParams, oldParams, state, sdk }) => {
    if (newParams?.project !== oldParams?.project && newParams?.owner && newParams?.project) {
      state.project = null
      state.projectComponents = null
      state.projectPages = null
      state.projectState = null
      return sdk.getProjectByKey({ owner: newParams.owner, key: newParams.project }).then((p) => {
        state.project = p
      })
    }
  }
}
